/**
 * SouthIndianTradition — design tokens.
 *
 * Mustard yellow, maroon, and green palette for Tamil/Telugu/Kannada wedding.
 */

import type { CSSProperties } from 'react';

export interface SouthIndianTheme {
  mustard: string;
  mustardDark: string;
  maroon: string;
  maroonDark: string;
  green: string;
  greenDark: string;
  ivory: string;
  ivoryDark: string;
  ink: string;
  muted: string;
  border: string;
}

export const southIndianTheme: SouthIndianTheme = {
  mustard: '#cba135',
  mustardDark: '#9f7e28',
  maroon: '#843c3a',
  maroonDark: '#5a2c2a',
  green: '#4a7e4d',
  greenDark: '#3a624f',
  ivory: '#fdf9f0',
  ivoryDark: '#f3edc2',
  ink: '#1f1103',
  muted: '#634f41',
  border: 'rgba(132, 60, 58, 0.12)',
};

export const SOUTH_INDIA_EASE = [0.22, 1, 0.36, 1] as const;

export function themeCssVars(theme: SouthIndianTheme): CSSProperties {
  return {
    '--si-mustard': theme.mustard,
    '--si-mustard-dark': theme.mustardDark,
    '--si-maroon': theme.maroon,
    '--si-maroon-dark': theme.maroonDark,
    '--si-green': theme.green,
    '--si-green-dark': theme.greenDark,
    '--si-ivory': theme.ivory,
    '--si-ivory-dark': theme.ivoryDark,
    '--si-ink': theme.ink,
    '--si-muted': theme.muted,
    '--si-border': theme.border,
  } as CSSProperties;
}
